import { z } from "zod";
import { SEARCH_CRITERIA, SEARCH_TYPE } from "./consts";

export const schema = z.object({
  [SEARCH_TYPE]: z.string().optional(),
  [SEARCH_CRITERIA]: z.any().optional(),
});

export type formValues = z.infer<typeof schema>;
